import styled from 'styles/styled-components';

const Wrapper = styled.div`
  ${({ isHomePage }) =>
    isHomePage
      ? `
    width: 100%;
    min-height: 100vh;
  `
      : `
    display: flex;
    align-items: center;
    justify-content: center;
  `}
`;

export default Wrapper;
